import Swiper, { Lazy, Autoplay, EffectFade } from 'swiper'
import gsap from 'gsap'
Swiper.use([ Lazy ]);
import counterUp from 'counterup2'


export default {
    counterThis() {
        const callback = entries => {
            entries.forEach( entry => {
                const el = entry.target
                if ( entry.isIntersecting ) {
                    counterUp( el, {
                        duration: 2000,
                        delay: 16,
                    } )
                }
            } )
        }

        const IO = new IntersectionObserver( callback, { threshold: 1 } )





        $('.counter-number').each(function(){
            IO.observe( this )
        })


    },
    sliderVerticalHome() {
        const elem = $('.vertical-slider-home')
        if(elem.length) {
            const sliderHome = new Swiper(elem[0], {
                speed: 1000,
                direction: 'vertical',
                slidesPerView: 'auto',
                // lazy: {
                //     loadPrevNext: true,
                // },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                touchRatio: 0,
                loop: true,
            })

        }
    },
    heroHomeActions() {
        $(document.body).on('click','.hero-home__item.is-extendable', function() {
            $(this).find('.hero-home__discover').addClass('clicked')
            const elem = this
            let tl = gsap.timeline()
            tl.to([$('.hero-home__text'), $('.hero-home__discover')],
                0.45,
                {
                    opacity: 0,
                    translateY: '20px',
                    ease: 'power1.out',
                    onComplete: () => {
                        $('.hero-home__text').addClass('expanded')
                        $('.hero-home__discover').addClass('expanded')
                        $(this).find('.content-expanded').addClass('show')
                    },
                }
            )
            .to(this,
                0.45, {
                    minWidth:'100%',
                    ease: 'power1.out',
                    onComplete: () => {
                        setTimeout(() => {
                            $(this).find('.content-expanded').addClass('active')
                            $(this).addClass('finished')
                        }, 400)
                    }
                },
                "=-0.45"
            )

        })
    },
    init() {
        this.sliderVerticalHome()
        this.heroHomeActions()
        this.counterThis()
    },
}
